module.exports = __webpack_public_path__ + "media/images/favicon-2ca8a425c431947fb466359d490989c9.png";